import { Popover as Root, type PopoverOrigin, type PopoverProps } from './Popover';
import { PopoverContent, type PopoverContentProps } from './PopoverContent';
export { type PopoverOrigin, type PopoverProps, PopoverContent, type PopoverContentProps };

export const Popover = Object.assign(Root, {
  Content: PopoverContent
});

export { usePopover } from './usePopover';
